<template>
  <v-row>
    <v-col v-if="cab.length">
      <v-select
      label="Cab"
      :items="cab"
      v-model="attributes.cab"
      ></v-select>
    </v-col>
    <v-col v-if="body.length">
      <v-select
      label="Body"
      :items="body"
      v-model="attributes.body"
      ></v-select>
    </v-col>
    <v-col v-if="submodel.length">
      <v-select
      label="Submodel"
      :items="submodel"
      v-model="attributes.submodel"
      ></v-select>
    </v-col>
    <v-col v-if="trim.length">
      <v-select
      label="Trim"
      :items="trim"
      v-model="attributes.trim"
      ></v-select>
    </v-col>
    <v-col v-if="fabric.length">
      <v-select
      label="Original Seat Fabric"
      :items="fabric"
      v-model="attributes.fabric"
      ></v-select>
    </v-col>
    <v-col v-if="engine.length">
      <v-select
      label="Engine"
      :items="engine"
      v-model="attributes.engine"
      ></v-select>
    </v-col>
    <v-col v-if="numberPassengers.length">
      <v-select
      label="Number of Passengers"
      :items="numberPassengers"
      v-model="attributes.numberPassengers"
      ></v-select>
    </v-col>
    <v-col v-if="drive.length">
      <v-select
      label="Drive"
      :items="drive"
      v-model="attributes.drive"
      ></v-select>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
::v-deep .v-list-item__title {
  white-space: pre-wrap !important;
} 
</style>

<script>
  import { mapState } from 'vuex'
  import { camelize } from '@/utils'
  import Attributes from '@/services/attributes'

  const attributeList = [
  'Cab',
  'Body',
  'Submodel',
  'Trim',
  'Fabric',
  'Engine',
  'NumberPassengers',
  'Drive'
  ]

  function mapProps(list) {
    return list.reduce(function(acc, prop) {
      acc[camelize(prop)] = function() {
        return this.getAttribute(prop)
      }
      return acc
    }, {})
  }

  export default {
    name: 'Attributes',
    data () {
      return {
        attrs: {},
      }
    },
    computed: {
      ...mapState([
        'year',
        'make',
        'model',
        'attributes'
        ]),
      ...mapProps(attributeList),
    },
    watch: {
      'model': function (model) {
        if (model) {
          this.initAttributes(this.year, this.make.makeId, model.modelId)
        } else {
          this.resetAttributes()
        }
      },
      'attributes': {
        handler: function (attributes) {
          this.$store.commit('setAttributes', attributes)
        },
        deep: true
      },
    },
    methods: {
      async initAttributes (year, make, model) {
        const attrs = this.attrs = await Attributes.get(year, make, model)
        const initial = attributeList.reduce((acc, attr) => {
          if (attrs[`include${attr}`]) {
            acc[camelize(attr)] = null
          }
          return acc
        }, {})
        this.$store.commit('setAttributes', initial)
      },
      resetAttributes() {
        this.$store.commit('setAttributes', {})
      },
      getAttribute(attr) {
        if (this.attrs[`include${attr}`]) {
          return this.attrs[camelize(attr)].split('|').filter(str => str.length)
        }
        return []
      }
    }
  }
</script>
